import { FORM_STATUS_LABEL, type FormStatus } from "@colab/shared";
import { cn } from "@/lib/utils";

// Patterned after components/shared/partner-status-badge.tsx but tuned for
// the three form lifecycle states (draft / published / archived). Phase 7
// sub-bucket 11 — colocated under features/admin/forms because forms are
// the only consumer today; promote to components/shared/ if a second admin
// surface needs it.

const STYLES: Record<FormStatus, string> = {
  draft: "bg-muted text-muted-foreground ring-border",
  published: "bg-status-active/10 text-status-active ring-status-active/25",
  archived: "bg-status-lost/10 text-status-lost ring-status-lost/25",
};

const DOT_STYLES: Record<FormStatus, string> = {
  draft: "bg-muted-foreground",
  published: "bg-status-active",
  archived: "bg-status-lost",
};

export function FormStatusBadge({
  status,
  className,
}: {
  status: FormStatus;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider ring-1",
        STYLES[status],
        className,
      )}
    >
      <span
        aria-hidden
        className={cn("inline-block h-1.5 w-1.5 rounded-full", DOT_STYLES[status])}
      />
      {FORM_STATUS_LABEL[status]}
    </span>
  );
}
